var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.349 6.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 108h24v24H20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -5.292 -28.578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 125.114a5.114 5.114 0 0 1-4.613-7.322l-3.253-3.253c-1.682 1.547-2.995 3.23-3.768 4.313a1.99 1.99 0 0 0 0 2.301c1.753 2.456 6.3 8.02 11.634 8.02 1.833 0 3.577-.656 5.147-1.621l-2.934-2.935a5.2 5.2 0 0 1-2.213.497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 124.341c.558 0 1.106-.107 1.622-.314l-5.649-5.648A4.34 4.34 0 0 0 32 124.341M39.041 126.183c2.077-1.716 3.699-3.778 4.59-5.03a1.995 1.995 0 0 0 0-2.302c-1.75-2.465-6.296-8.025-11.63-8.025-2.204 0-4.276.952-6.07 2.241l-4.89-4.889a.61.61 0 0 0-.862.019.61.61 0 0 0 0 .844l22.78 22.781a.61.61 0 0 0 .863-.019.61.61 0 0 0 0-.844zm-7.04-11.297a5.106 5.106 0 0 1 5.114 5.105 5.1 5.1 0 0 1-1.097 3.168l-.549-.553a4.337 4.337 0 0 0-6.075-6.075l-.553-.553a5.1 5.1 0 0 1 3.16-1.092"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.87953f3a375c2cb849c3b6827b6c8484.svg";
export { ForwardRef as ReactComponent };